import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SArticle = styled.article`
  max-width: ${pxToRem(766)}rem;
  margin: 0 auto;

  @media ${BREAKPOINTS.LG.max} {
    margin-top: 3vw;
    max-width: unset;
  }
`

export const SArticleHeader = styled.div`
  position: relative;
  margin-bottom: 3.5625rem;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid var(--c-blue100);
    transform: translate(2.215rem, 2.215rem);
    z-index: -1;
  }
`

export const SArticleContent = styled.div`
  max-width: ${pxToRem(600)}rem;
  margin-left: auto;
  margin-right: auto;
`

export const SMoreArticles = styled.div`
  max-width: ${pxToRem(895)}rem;
  margin: 0 auto;
  margin-bottom: ${pxToRem(120)}rem;

  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(${pxToRem(250)}rem, 1fr));

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: ${pxToRem(30)}rem;
    max-width: unset;
  }
`

export const ArticleContentText = styled(Text)`
  margin-bottom: 2rem;
`

export const ArticleContentImage = styled.img`
  margin-bottom: 1rem;
  max-width: 100%;
`
